module.exports = __webpack_public_path__ + "img/icon5-1-1024x1024.0ca47729.png";